<script setup>
import { RouterLink, useLink } from 'vue-router';
import { computed } from 'vue';

const props = defineProps({
  // add @ts-ignore if using TypeScript
  ...RouterLink.props,
  inactiveClass: String,
  domain: {
    type: String,
    default: import.meta.env.VUE_APP_BASE_URL,
  },
});

const {
  // the href to use in a link
  href,
  // boolean ref indicating if the link is active
  isActive,
  // boolean ref indicating if the link is exactly active
  isExactActive,

  ...rest
} = useLink(props);

const isExternalLink = computed(
  () => typeof props.to === 'string' && props.to.startsWith('http')
)

const isSameDomain = computed(() => {
  const domain = new URL(props.domain);
  return domain.hostname === location.hostname;
})

const classes = computed(() => ({
  [props.activeClass || 'router-link-active']: isActive.value,
  [props.exactActiveClass || 'router-link-exact-active']: isExactActive.value,
  [props.inactiveClass || '']: !isActive.value,
}))
</script>

<template>
    <RouterLink v-if="isSameDomain" v-bind="$attrs" :to="props.to">
        <slot />
    </RouterLink>
    <a v-else-if="isExternalLink" v-bind="$attrs" :href="props.to" :class="classes">
        <slot />
    </a>
    <a v-else v-bind="$attrs" :href="`${props.domain}${href}`" :class="classes">
        <slot />
    </a>
</template>